{
  "reports": {
    "status": {
      "not_found": "Aucun rapport trouvé"
    },
    "actions": {
      "save_report": "Enregistrer le rapport",
      "edit_report": "Modifier le rapport",
      "discard_changes": "Annuler les modifications"
    },
    "info": {
      "created_by": "Créé par :",
      "created_on": "Créé le :",
      "last_updated": "Dernière mise à jour :"
    },
    "fields": {
      "report_title": "Titre du rapport"
    },
    "confirmations": {
      "discard_all_title": "Annuler toutes les modifications",
      "discard_all_content": "Êtes-vous sûr de vouloir annuler les modifications du rapport ?",
      "exit_edit_mode": "Quitter le mode édition"
    }
  },
  "sections": {
    "all_sections": "Toutes les sections",
    "create_section": "Créer une section",
    "back_to_all_sections": "Retour à toutes les sections",
    "actions": {
      "save_changes": "Enregistrer les modifications",
      "discard_changes": "Annuler les modifications",
      "edit_section": "Modifier la section",
      "delete_section": "Supprimer la section"
    },
    "file_summary": {
      "replace_file": "Remplacer le fichier",
      "replace_file_warning": "Une fois que vous cliquez sur régénérer, le fichier sera remplacé et vous ne pourrez pas annuler les modifications.",
      "regenerate": "Régénérer"
    },
    "fields": {
      "ai_prompt": "Invite IA",
      "section_title": "Titre de la section",
      "sources": "Sources"
    },
    "confirmations": {
      "discard_title": "Annuler les modifications de la section",
      "discard_content": "Êtes-vous sûr de vouloir annuler les modifications de cette section ?"
    },
    "types": {
      "add_blank_section": "Ajouter une section vierge",
      "blank_section": "Section vierge",
      "blank_section_description": "Commencer avec un éditeur de texte enrichi vide uniquement",
      "file_summary": "Résumé de fichier",
      "file_summary_description": "Téléverser un fichier pour résumer le document à l'aide d'invites IA",
      "ai_web_search": "Recherche Web IA",
      "ai_web_search_description": "Rechercher sur les sites Web publics pour trouver du contenu pertinent pour votre rapport.",
      "nexl_data": "Données Nexl",
      "nexl_data_description": "Sélectionner le type de section et générer du contenu à l'aide des données Nexl"
    }
  },
  "status": {
    "success": {
      "title": "Généré avec succès !"
    },
    "error": {
      "title": "Une erreur s'est produite lors de la génération de la section.",
      "description": "Veuillez réessayer plus tard ou contacter le support si le problème persiste."
    },
    "loading": {
      "title": "Génération du contenu de la section...",
      "description": "Cela peut prendre un moment."
    },
    "alt": {
      "title": "Génération du contenu de la section...",
      "description": "Cela peut prendre un moment."
    }
  },
  "agent-state": {
    "connecting": "Connexion à l'agent IA...",
    "disconnecting": "Déconnexion de l'agent IA...",
    "disconnected": "Nous nous excusons, notre IA semble être hors ligne. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez contacter votre Administrateur.",
    "error": "Nous nous excusons, il semble y avoir une erreur avec notre IA. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez contacter votre Administrateur."
  },
  "validation": {
    "report_title_required": "Le titre du rapport est requis",
    "section_title_required": "Le titre de la section est requis"
  },
  "prompt_library": {
    "title": "Catalogue de prompts",
    "info": {
      "data_source": "Source de données",
      "created_at": "Date de création",
      "error": "Erreur",
      "no_prompts": "Aucun prompt trouvé",
      "all_tags": "Toutes les étiquettes"
    },
    "actions": {
      "create_new_tag": "Créer une nouvelle étiquette",
      "filter": "Filtrer",
      "create_prompt": "Créer un prompt",
      "edit": "Modifier le prompt",
      "delete": "Supprimer le prompt"
    },
    "placeholders": {
      "prompt_search": "Rechercher par catégorie, titre du prompt"
    },
    "aria_labels": {
      "prompt_search": "Rechercher prompts par catégorie ou titre"
    }
  }
}
